import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { ROUTES } from '../../routes';
import { SIGNUP_URL } from '../../constants/config';
import WarnIcon from './icons/WarnIcon';
import { ConfirmationModal } from '../ConfirmationModal';
import { useMixPanel } from '../MixPanel/useMixPanel';
import { useGoogleAnalytics } from '../GoogleAnalytics/useGoogleAnalytics';
import { MixpanelEvent } from '../MixPanel/events/events';
import { useFirebase } from '../../context';

const SsuLogoutFooter: React.FC = (): JSX.Element => {
  const { user } = useAppSelector((state) => state.auth);

  const { user: firebaseUser } = useFirebase();

  const pricingPageMatch = useRouteMatch(ROUTES.PRICING);
  const paymentDetailsPageMatch = useRouteMatch(ROUTES.PAYMENT_DETAILS);

  const [isModalOpened, setModalOpened] = useState(false);

  const { trackEvent } = useMixPanel();
  const { trackGAEvent } = useGoogleAnalytics();

  const email = user?.email || firebaseUser?.email || '';

  const attrs = {
    container: {
      className: `ssu-logout-footer${email ? ' ssu-logout-footer--ready' : ''}`,
    },
    email: {
      className: 'ssu-logout-footer-email',
    },
    logoutLink: {
      className: 'ssu-logout-footer-link',
      onClick: () => {
        setModalOpened(true);
      },
    },
    confirmLogoutModal: {
      icon: WarnIcon,
      isOpened: isModalOpened,
      className: 'ssu-logout-footer-confirmation-modal',
      title: 'Do you want to cancel registration?',
      description:
        'By signing out now, your registration process will be paused and your email will be signed out of the Substrata.',
      footerProps: {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Sign Out',
        onCancel: () => {
          setModalOpened(false);
        },
        onConfirm: () => {
          if (pricingPageMatch) {
            trackEvent(MixpanelEvent.PRICING_PAGE_LOGOUT_BUTTON_CLICK);
            trackGAEvent(
              'event',
              MixpanelEvent.PRICING_PAGE_LOGOUT_BUTTON_CLICK
            );
          }
          if (paymentDetailsPageMatch) {
            trackEvent(MixpanelEvent.PAYMENT_DETAILS_PAGE_LOGOUT_BUTTON_CLICK);
            trackGAEvent(
              'event',
              MixpanelEvent.PAYMENT_DETAILS_PAGE_LOGOUT_BUTTON_CLICK
            );
          }
          window.location.href = `${SIGNUP_URL}${ROUTES.LOGOUT}`;
        },
      },
      onClose: () => {
        setModalOpened(false);
      },
    },
  };

  return (
    <div {...attrs.container}>
      {email ? (
        <>
          <span>You&apos;re signing up as</span>
          <span {...attrs.email}>{email}.</span>
          <span>Wrong account?</span>
          <span {...attrs.logoutLink}>Sign Out</span>
          <ConfirmationModal {...attrs.confirmLogoutModal} />
        </>
      ) : null}
    </div>
  );
};

export default SsuLogoutFooter;
